import React from 'react'
import TopNavbar from '../Nav/TopNavbar'
import Header from '../Sections/Header'
import RsopHeader from './RsopHeader'
import PricingCompo from '../Products/PricingCompo'


import {
  Flex,
  Container,
  Heading,
  Stack,
  Text,
  Button,
  Icon,
  IconProps,
  VStack,
} from '@chakra-ui/react';
import NewNavbar from '../Nav/NewNavbar'
import Contact from '../Sections/Footer'
import VideoFeature from '../Features/VideoFeature'
import ImageCol from '../Features/ImageCol'
import IconStat from '../Features/IconStat'
import BigReview from '../Features/BigReview'

export default function RsopHome() {
  return (
    <>
    <NewNavbar/>
    {/* <TopNavbar/> */}

    <VStack gap={10}>
    <RsopHeader/>

    <div>
    <Container maxW={'5xl'}>
      <Stack
        textAlign={'center'}
        align={'center'}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 20, md: 28 }}>
        <Heading
          fontWeight={600}
          fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
          lineHeight={'110%'}>
          SOP Review{' '}
          <Text as={'span'} color={"rgb(20, 93, 160)"}>
            made easy
          </Text>
        </Heading>
        <Text color={'gray.500'} maxW={'3xl'}>
          Never miss a meeting. Never be late for one too. Keep track of your
          meetings and receive smart reminders in appropriate times. Read your
          smart “Daily Agenda” every morning.
        </Text>

      </Stack>
    </Container>
    </div>


    {/* <VideoFeature/> */}
    <ImageCol/>
    <IconStat/>
    <BigReview/>
    <Contact/>
    </VStack>
    </>

  )
}
